import { atom } from 'recoil';

export const teamAgentIds = atom({
  key: 'teamAgentIds', // unique ID (with respect to other atoms/selectors)
  default: [],
  // default value (aka initial value)
});
